import React, { useState } from "react";
import { animateScroll } from "react-scroll";

export default function MessageInput({
  onType,
  addMessage,
  username,
  type = "brand",
}) {
  const [value, setValue] = useState("");

  const onChange = (e) => setValue(e.target.value);

  const onAddMessage = () => {
    addMessage({
      type: type,
      message: value,
      username: username,
      time: new Date().getTime().toString(),
    });
    setValue("");
  };
  return (
    <div className={`message-input-wrapper`}>
      <div className="message-input-outer">
        <div className="message-input-container">
          <input
            type="text"
            value={value}
            onChange={onChange}
            onKeyPress={(e) => {
              onType();
              if (e.key === "Enter") onAddMessage();
            }}
            onFocus={() =>
              animateScroll.scrollToBottom({
                duration: 500,
                smooth: "easeInOutQuad",
              })
            }
          />

          <div
            className={`send-button ${value ? "" : "disabled"}`}
            onClick={(_e) => {
              if (value) onAddMessage();
            }}
          >
            Go
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/LiveChat/MessageInput.js